import Vue from 'vue'
import Router from 'vue-router'
var title = "乌丫咀uooyaazine"

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: resolve => require(['@/pages/index/index'], resolve),
    beforeEnter: (to, from, next) => {
      document.getElementById("mainTitle").innerHTML = title+"-homepage"
      next()
    }
  },{
    path: '/index',
    name: 'index',
    component: resolve => require(['@/pages/index/index'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-homepage"
        next()
    } 
  },{
    path: '/about',
    name: 'about',
    component: resolve => require(['@/pages/about/about'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-about"
        next()
    } 
  },{
    path: '/magazine',
    name: 'magazine',
    component: resolve => require(['@/pages/magazine/magazine'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-magazine"
        next()
    } 
  },{
    path: '/story',
    name: 'story',
    component: resolve => require(['@/pages/story/story'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-story"
        next()
    } 
  },{
    path: '/storyOld',
    name: 'storyOld',
    component: resolve => require(['@/pages/story/storyOld'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-storyOld"
        next()
    } 
  },{
    path: '/storyNew',
    name: 'storyNew',
    component: resolve => require(['@/pages/story/storyNew'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-storyNew"
        next()
    } 
  },{
    path: '/storySecondaryPage',
    name: 'storySecondaryPage',
    component: resolve => require(['@/pages/story/storySecondaryPage'], resolve),
    beforeEnter: (to, from, next) => {
        document.getElementById("mainTitle").innerHTML = title+"-storySecondaryPage"
        next()
    } 
  }],
  // mode:'history'   //去除#号 
})



// WEBPACK FOOTER //
// ./src/router/index.js